import * as formik from 'formik';
import * as yup from 'yup';
import { useState, useEffect } from 'react';
import FileDropArea from '../FileDropArea'
import { Modal, Button, Table, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { importAssets } from '../../utils/api';
import Loader from '../Loader';
import { useDataStore } from '../../Store';
import Success from '../Success';
import Error from '../Error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';

const ImportAssetModal = ({ show, onHide }) => {

    const selectedEntity = useDataStore((state) => state.selectedEntity);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const [filename, setFilename] = useState(false);
    const [fileType, setFileType] = useState(false);
    const [bytes, setBytes] = useState(false);

    useEffect(() => {
        resetState();
    }, [show]);

    const resetState = () => {
        setError(null);
        setLoading(false);
        setIsSaving(false);
        setIsSaved(false);
    };

    const uploadFile = async (filename, fileType, bytes) => {
        setFilename(filename);
        setFileType(fileType);
        setBytes(bytes);
    }

    const closeModal = (shouldRefresh) => {
        setLoading(false);
        setIsSaving(false);
        setError(null);
        setIsSaved(false);
        onHide(shouldRefresh);
    }

    const importClicked = async () => {
        if (!filename) return;
        if (!bytes) return;
        if (!fileType) return;

        setLoading(true);
        const data = await importAssets(selectedEntity, filename, bytes, fileType);
        const success = data?.Success ?? false;
        if (success) {
            setIsSaved(true);
        }
        else {
            setError("an error occured")
        }

        setIsSaving(false);
        setLoading(false);

        if (success)
            setTimeout(() => closeModal(true), 2000);
    }

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Import Assets</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading || isSaving ? <Loader /> : error ? <Error /> : isSaved ? (
                        <div style={{ height: 230, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Success />
                        </div>
                    ) : (
                        <>
                            <div style={{ padding: 10, textAlign: 'center' }}>
                                {bytes && (
                                    <>
                                        <FontAwesomeIcon icon={faFile} style={{ maxWidth: 180, width: 'auto', height: 84, }} />
                                        <p>{filename}</p>
                                    </>
                                ) || (
                                        <FileDropArea isCsv={true} style={{ minHeight: 250 }} onFileSelected={uploadFile} footerText='Recommended: .csv' />
                                    )}
                            </div>

                            <br />

                            <Button style={{ width: '100%' }} onClick={importClicked}>Import</Button>
                        </>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );
};

export default ImportAssetModal;